<template>
  <div class="sidebar-content sidebar-content--sleeves">
    <h1 class="sidebar-title">Snap Color</h1>
    <h3 class="sidebar-subtitle">Pick Snaps Color</h3>

    <ColorPicker
      :colors="colorsCategories.snapsColors"
      @onSelectColor="onSelectColor"
    />

    <div class="color-label">Selected Color:</div>
    <b>{{ snapsColor.title }}</b>
  </div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';

export default {
  name: 'SnapsSidebar',
  components: {
    ColorPicker,
  },

  data () {
    return {
      colors: [],
    };
  },

  computed: {
    snapsColor () {
      return this.$store.getters['design/getSnapsColor'];
    },

    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },

  methods: {
    onSelectColor (color) {
      this.$store.commit('design/setSnapsColor', { color });
    }
  }
};
</script>

<style scoped>
  .color-label {
    margin-top: 10px;
  }

  .description {
    font-size: 18px;
    text-align: left;
    padding: 0 30px 0 30px;
    margin-top: 20px;
    font-style: italic;
  }
</style>
